export const M5_MODULE_REVIEW = {
  id: "m5-module-review",
  title: "Module 5 Review / Repaso del Módulo 5",
  topic: "Complete Module 5 review! Test everything you learned: job applications, short questions, social planning, present continuous for future, going to for plans and predictions, entertainment vocabulary, making invitations, and expressing opinions. Show your mastery from A2 to solid B1!",
  iconType: "trophy",
  
  sets: [
    // ===================================================================
    // SET 1: Job Applications & Workplace (Units 11) - A2
    // ===================================================================
    {
      id: "m5-final-review-s1",
      title: "Set 1: Professional English",
      questions: [
        {
          type: "match",
          q: "SCENARIO: You're reading job advertisements. Match terms to meanings:",
          pairs: [
            { left: "Part-time", right: "Fewer than 40 hours per week" },
            { left: "Experience needed", right: "Must have done the job before" },
            { left: "Salary", right: "Money you earn from work" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "SCENARIO: You're applying for a job. What do you send with your application?",
          options: ["Resume and cover letter", "Only your photo", "Nothing"],
          a: "Resume and cover letter",
          tip: "Resume (US) = CV (UK)"
        },
        {
          type: "input",
          q: "INTERVIEW: 'Why do you want this job?' Best word to show enthusiasm: 'I'm very ___ about this opportunity.'",
          a: "excited",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["interested", "enthusiastic", "passionate"] }
        },
        {
          type: "order",
          q: "SCENARIO: Put the job application process in order:",
          words: ["Look", "for", "job", "→", "Apply", "→", "Interview", "→", "Get", "job"],
          a: "Look for job → Apply → Interview → Get job"
        },
        {
          type: "mc",
          q: "WORKPLACE: Your boss says 'Can you work overtime this week?' This means:",
          options: ["Work extra hours beyond regular schedule", "Work faster", "Take a break"],
          a: "Work extra hours beyond regular schedule"
        },
        {
          type: "input",
          q: "REFERENCE: 'Can you give me a ___?' This means: write a recommendation letter. (one word)",
          a: "reference",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "match",
          q: "SCENARIO: Match workplace people to descriptions:",
          pairs: [
            { left: "Manager", right: "Leads a team or department" },
            { left: "Staff", right: "All the employees" },
            { left: "Customer", right: "Person who buys/uses service" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "REAL SITUATION: You want more money at work. You ask for a:",
          options: ["Salary raise", "New job", "Day off"],
          a: "Salary raise",
          tip: "Raise (US) = Rise (UK)"
        },
        {
          type: "input",
          q: "QUALIFICATION: 'I have a ___ in Computer Science.' (university degree)",
          a: "degree",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["bachelor's degree", "bachelor degree"] }
        },
        {
          type: "mc",
          q: "SCENARIO: Interview question - 'When can you start?' You're available immediately. Say:",
          options: ["I can start immediately", "I started yesterday", "I will starting soon"],
          a: "I can start immediately"
        },
        {
          type: "order",
          q: "PROFESSIONAL RESPONSE: Build answer to 'Why did you leave your last job?'",
          words: ["I", "wanted", "new", "challenges", "and", "growth", "opportunities"],
          a: "I wanted new challenges and growth opportunities",
          tip: "Stay positive about previous employers!"
        },
        {
          type: "mc",
          q: "COMPREHENSION: What makes a good job interview answer?",
          options: ["Specific, honest, positive, and relevant to the job", "Very short answers", "Criticizing previous jobs"],
          a: "Specific, honest, positive, and relevant to the job"
        }
      ]
    },

    // ===================================================================
    // SET 2: Conversation Skills & Social Planning (Units 12, 13) - A2+
    // ===================================================================
    {
      id: "m5-final-review-s2",
      title: "Set 2: Natural Conversations",
      questions: [
        {
          type: "match",
          q: "SCENARIO: Someone tells you something. Match statements to natural responses:",
          pairs: [
            { left: "I went to Paris", right: "Did you?" },
            { left: "It was amazing", right: "Was it?" },
            { left: "I love this place", right: "Do you?" }
          ],
          a: "completed",
          tip: "Short questions show interest!"
        },
        {
          type: "mc",
          q: "REAL CONVERSATION: 'I saw that new movie last night.' Natural engaged response:",
          options: ["Did you? How was it?", "OK.", "Really?"],
          a: "Did you? How was it?",
          tip: "Short question + follow-up = native pattern"
        },
        {
          type: "input",
          q: "SHORT QUESTION: 'She's moving to London.' → '___ she?' (short question)",
          a: "Is",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "order",
          q: "SCENARIO: Build natural invitation:",
          words: ["I'm", "going", "to", "the", "concert", "Friday.", "Want", "to", "come?"],
          a: "I'm going to the concert Friday. Want to come?"
        },
        {
          type: "mc",
          q: "MAKING PLANS: 'What are you doing tomorrow?' 'I ___ meeting my parents at 3pm.'",
          options: ["'m", "do", "will"],
          a: "'m",
          tip: "Present continuous for arranged future plans"
        },
        {
          type: "input",
          q: "POLITE REFUSAL: 'Can you come to dinner?' 'Sorry, I can't. I'm ___ late.' (work + ing)",
          a: "working",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "match",
          q: "SCENARIO: Going out - Match places to activities:",
          pairs: [
            { left: "Restaurant", right: "Have dinner" },
            { left: "Concert hall", right: "Listen to live music" },
            { left: "Art gallery", right: "Look at paintings" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "TIME EXPRESSION: 'The movie starts ___ Saturday ___ 8pm.'",
          options: ["on ... at", "in ... on", "at ... in"],
          a: "on ... at",
          tip: "Day = on, Time = at"
        },
        {
          type: "input",
          q: "ACCEPTING INVITATION: 'Do you want to join us?' Enthusiastic response: 'I'd ___ to!'",
          a: "love",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "REAL SITUATION: You can't make Friday but want to keep the friendship. Say:",
          options: ["Sorry, I can't Friday. How about Saturday?", "No.", "I'm busy."],
          a: "Sorry, I can't Friday. How about Saturday?",
          tip: "Sorry + excuse + alternative = polite and friendly"
        },
        {
          type: "order",
          q: "SCENARIO: Complete planning conversation:",
          words: ["What", "time", "are", "we", "meeting?", "How", "about", "7pm?", "Perfect!"],
          a: "What time are we meeting? How about 7pm? Perfect!"
        },
        {
          type: "mc",
          q: "COMPREHENSION: Good social English requires:",
          options: ["Showing interest, being polite, and making specific plans", "Just saying yes or no", "Never asking questions"],
          a: "Showing interest, being polite, and making specific plans"
        }
      ]
    },

    // ===================================================================
    // SET 3: Future with Going To (Unit 14) - B1-
    // ===================================================================
    {
      id: "m5-final-review-s3",
      title: "Set 3: Talking About the Future",
      questions: [
        {
          type: "match",
          q: "SCENARIO: Identify going to uses:",
          pairs: [
            { left: "I'm going to study tonight", right: "Plan (decided)" },
            { left: "Look at the sky! It's going to rain", right: "Prediction (evidence)" },
            { left: "Both use same grammar!", right: "Context shows which" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "PERSONAL PLAN: 'What are your plans?' 'I ___ visit my family next month.'",
          options: ["'m going to", "visit", "visited"],
          a: "'m going to",
          tip: "Definite plan = going to"
        },
        {
          type: "input",
          q: "PREDICTION: 'She didn't study. She's going to ___ the exam.' (fail)",
          a: "fail",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "order",
          q: "SCENARIO: Build travel plan with time:",
          words: ["We're", "going", "to", "Paris", "in", "two", "months"],
          a: "We're going to Paris in two months"
        },
        {
          type: "mc",
          q: "QUESTION FORM: '___ you going to watch the movie tonight?'",
          options: ["Are", "Do", "Will"],
          a: "Are",
          tip: "Question: Are/Is + subject + going to + verb?"
        },
        {
          type: "input",
          q: "NEGATIVE: 'I'm not going to ___ to the party. I'm too tired.' (go)",
          a: "go",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "match",
          q: "SCENARIO: Match time expressions to meanings:",
          pairs: [
            { left: "Next week", right: "The week after this one" },
            { left: "In three days", right: "Three days from now" },
            { left: "By Friday", right: "Before or on Friday (deadline)" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "REAL SITUATION: You see dark clouds. Say:",
          options: ["It's going to rain soon", "It rains soon", "It rained"],
          a: "It's going to rain soon",
          tip: "Evidence you can see = going to for prediction"
        },
        {
          type: "input",
          q: "DEADLINE: 'I need to finish this ___ Monday.' (by/before or on)",
          a: "by",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "SCENARIO: Which shows a PLAN (not prediction)?",
          options: ["I'm going to buy a car next month", "He's going to drop that box!", "It's going to be cold tomorrow"],
          a: "I'm going to buy a car next month",
          tip: "Personal decision about future = plan"
        },
        {
          type: "order",
          q: "COMBINING: Build plan + prediction:",
          words: ["I'm", "going", "to", "try", "that", "restaurant.", "I", "think", "it's", "going", "to", "be", "good."],
          a: "I'm going to try that restaurant. I think it's going to be good."
        },
        {
          type: "mc",
          q: "COMPREHENSION: Going to is used for:",
          options: ["Decided plans and predictions based on evidence", "Only plans", "Only predictions"],
          a: "Decided plans and predictions based on evidence"
        }
      ]
    },

    // ===================================================================
    // SET 4: Entertainment, Opinions & Complex Planning (Units 12, 13, 14) - B1
    // ===================================================================
    {
      id: "m5-final-review-s4",
      title: "Set 4: Expressing Yourself",
      questions: [
        {
          type: "match",
          q: "SCENARIO: Movie night - Match genres to descriptions:",
          pairs: [
            { left: "Thriller", right: "Suspenseful, mysterious, exciting" },
            { left: "Comedy", right: "Funny, makes you laugh" },
            { left: "Documentary", right: "Real-life, factual, educational" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "OPINION: 'Have you seen the trailer? This movie ___ amazing!'",
          options: ["looks", "is looking", "looked"],
          a: "looks",
          tip: "'Looks' + adjective = appears to be"
        },
        {
          type: "input",
          q: "PREDICTION + OPINION: 'I think the concert is going to be ___!' (amazing/great/incredible)",
          a: "amazing",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["incredible", "fantastic", "awesome", "great"] }
        },
        {
          type: "order",
          q: "SCENARIO: Restaurant - Build complete request:",
          words: ["Can", "I", "have", "the", "check,", "please?"],
          a: "Can I have the check, please?",
          tip: "Check (US) = Bill (UK)"
        },
        {
          type: "mc",
          q: "REAL SITUATION: Friend says 'This restaurant looks expensive.' You agree. Say:",
          options: ["It does! Let's go somewhere else.", "No, it doesn't.", "Maybe."],
          a: "It does! Let's go somewhere else.",
          tip: "Short answer + suggestion = natural conversation"
        },
        {
          type: "input",
          q: "INVITING WITH OPINION: 'I'm going to see that new thriller. I think you'd ___ it. Want to come?' (like)",
          a: "love",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["like", "enjoy"] }
        },
        {
          type: "match",
          q: "SCENARIO: Making excuses - Match to situations:",
          pairs: [
            { left: "I'm studying for an exam", right: "Academic excuse" },
            { left: "I'm visiting family", right: "Family excuse" },
            { left: "I'm working late", right: "Work excuse" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "POLITE DISAGREEMENT: Friend says 'This movie is great!' You disagree. Say:",
          options: ["Really? I don't think it's very good.", "You're wrong.", "No."],
          a: "Really? I don't think it's very good.",
          tip: "Short question + your opinion = soft disagreement"
        },
        {
          type: "input",
          q: "EXPRESSING PREFERENCE: 'I don't like ___. They're too scary for me.' (genre)",
          a: "horror movies",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["horror", "horror films", "thrillers"] }
        },
        {
          type: "mc",
          q: "COORDINATING: 'What time should we meet?' 'How about 7?' 'That ___ perfect!'",
          options: ["sounds", "sound", "sounded"],
          a: "sounds",
          tip: "'Sounds' + adjective = seems/appears"
        },
        {
          type: "order",
          q: "SCENARIO: Complete natural exchange:",
          words: ["This", "place", "looks", "great!", "I", "think", "we're", "going", "to", "love", "it.", "Let's", "go", "in!"],
          a: "This place looks great! I think we're going to love it. Let's go in!"
        },
        {
          type: "mc",
          q: "COMPREHENSION: Natural conversations combine:",
          options: ["Opinions, predictions, plans, invitations, and responses", "Only questions", "Only statements"],
          a: "Opinions, predictions, plans, invitations, and responses"
        }
      ]
    },

    // ===================================================================
    // SET 5: MASTERY - Real-World Integration (All Units) - B1+
    // ===================================================================
    {
      id: "m5-final-review-s5",
      title: "Set 5: Module 5 Mastery",
      questions: [
        {
          type: "match",
          q: "FINAL REVIEW: Match Module 5 skills to contexts:",
          pairs: [
            { left: "Professional", right: "Job applications, interviews, workplace" },
            { left: "Social", right: "Making plans, invitations, going out" },
            { left: "Future", right: "Plans, predictions, time expressions" }
          ],
          a: "completed",
          successtip: "✓ You've mastered three major contexts! Professional, social, and future!"
        },
        {
          type: "mc",
          q: "COMPREHENSIVE SCENARIO: Your friend texts: 'Are you free Saturday? I'm going to that new restaurant. Want to come?' Best response:",
          options: ["I'd love to! What time are we meeting? I think it's going to be great!", "Maybe.", "OK."],
          a: "I'd love to! What time are we meeting? I think it's going to be great!",
          tip: "Enthusiasm + question + opinion = complete response",
          successtip: "✓ Perfect! Combined: acceptance (I'd love to), planning (what time), and prediction (going to be great)!"
        },
        {
          type: "input",
          q: "WORKPLACE SCENARIO: Boss asks 'Can you work this weekend?' You have plans. Say: 'I'm sorry, I can't. I'm ___ visit my family.' (going to)",
          a: "going to",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "order",
          q: "REAL CONVERSATION: Build complete exchange combining everything:",
          words: ["What", "are", "you", "doing", "tomorrow?", "I'm", "meeting", "friends", "for", "dinner.", "Are", "you?", "Sounds", "fun!", "Where", "are", "you", "going?"],
          a: "What are you doing tomorrow? I'm meeting friends for dinner. Are you? Sounds fun! Where are you going?",
          successtip: "✓ Natural flow: question → answer → short question → reaction → follow-up. Native-level!"
        },
        {
          type: "mc",
          q: "MASTER SCENARIO: Interview question - 'What are your plans for the future?' Best answer:",
          options: ["I'm going to develop my skills and take on new challenges in this field", "I don't know", "I want to be rich"],
          a: "I'm going to develop my skills and take on new challenges in this field",
          tip: "Specific, positive, relevant to job",
          successtip: "✓ Professional answer: uses going to, shows ambition, stays relevant!"
        },
        {
          type: "input",
          q: "COMPLEX PLANNING: 'I can't make it Friday, but I'm ___ on Saturday. Does that work?' (available)",
          a: "free",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["available"] }
        },
        {
          type: "match",
          q: "MASTERY CHECK: Three future forms you've learned:",
          pairs: [
            { left: "Present continuous", right: "I'm meeting them tomorrow (arrangement)" },
            { left: "Going to (plan)", right: "I'm going to study tonight (decided)" },
            { left: "Going to (prediction)", right: "It's going to rain (evidence)" }
          ],
          a: "completed",
          successtip: "✓ You can express future in THREE ways! That's advanced English!"
        },
        {
          type: "mc",
          q: "REAL-WORLD APPLICATION: You're at a job interview. They ask 'Why should we hire you?' You want to show confidence and enthusiasm. Best approach:",
          options: ["Combine qualifications, experience, and enthusiasm for the role", "Say you need money", "Say you're okay"],
          a: "Combine qualifications, experience, and enthusiasm for the role",
          tip: "Specific examples + positive attitude = strong answer"
        },
        {
          type: "input",
          q: "SOCIAL MASTERY: Friend asks opinion about a movie. You respond: 'I ___ it looks interesting. I'm going to see it next week. Want to join?' (think)",
          a: "think",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "ADVANCED SCENARIO: Multiple friends are coordinating. Someone says 'I'm working until 6.' Another says 'I'm not free until 7.' You suggest:",
          options: ["How about we meet at 7:30? That works for everyone.", "Let's cancel.", "I don't care."],
          a: "How about we meet at 7:30? That works for everyone.",
          tip: "Compromise + confirmation = good coordination",
          successtip: "✓ Problem-solving in English! Find solutions that work for everyone!"
        },
        {
          type: "order",
          q: "ULTIMATE INTEGRATION: Build complete natural conversation:",
          words: ["Did", "you", "get", "the", "job?", "Yes!", "I'm", "starting", "next", "month!", "That's", "amazing!", "I", "think", "you're", "going", "to", "love", "it."],
          a: "Did you get the job? Yes! I'm starting next month! That's amazing! I think you're going to love it.",
          successtip: "✓ MASTERFUL! Short question (Did you?) + present continuous future (I'm starting) + enthusiasm (That's amazing!) + prediction (going to love)!"
        },
        {
          type: "mc",
          q: "🏆 FINAL MASTERY QUESTION 🏆\n\nYou've completed Module 5! You can now:\n• Navigate job applications and interviews professionally\n• Make conversation naturally with short questions\n• Plan social activities and make/accept/decline invitations politely\n• Express future plans and predictions confidently\n• Give opinions about entertainment and experiences\n• Coordinate complex plans with multiple people\n\nWhat's the most important thing you learned?",
          options: ["How to communicate naturally in professional AND social contexts in English", "Just grammar rules", "Just vocabulary"],
          a: "How to communicate naturally in professional AND social contexts in English",
          successtip: "🎊🏆🌟 CONGRATULATIONS! MODULE 5 COMPLETE! 🌟🏆🎊\n\nYou've achieved B1 level mastery! You started with basic job vocabulary and now you can:\n✅ Handle professional situations (interviews, workplace communication)\n✅ Have natural conversations (short questions, showing interest)\n✅ Make and coordinate social plans (invitations, excuses, scheduling)\n✅ Talk about the future with confidence (three different forms!)\n✅ Express opinions and preferences naturally\n✅ Navigate real-world scenarios from work meetings to weekend plans\n\nFrom A2 to solid B1 - you didn't just learn English, you learned to USE English like a native speaker in real situations! This is functional, practical, REAL English.\n\nYou're ready for authentic English conversations in professional settings, social situations, and everyday life. Be proud of this achievement! 🚀🎉✨\n\nModule 6 awaits... but for now, celebrate! You've earned it! 🥳🎊"
        }
      ]
    }
  ]
};
